import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_comfort-systems-5/artifacts/2ev0qwwv_ChatGPT%20Image%2026%20f%C3%A9vr.%202026%2C%2016_32_30.png" 
                alt="CG Énergies" 
                className="h-32 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Votre expert en climatisation, chauffage, pompe à chaleur et ventilation dans les Hauts-de-France. 
              Solutions sur-mesure pour votre confort.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('hero')} className="hover:text-blue-400 transition-colors">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-blue-400 transition-colors">
                  Nos Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-blue-400 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Nos Services</h4>
            <ul className="space-y-2">
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Pompe à Chaleur</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Climatisation</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">VMC & Ventilation</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Adoucisseur</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Chauffage</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Chauffe Eau</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <span className="font-semibold block">Béthune</span>
                  <span className="text-sm">Hauts-de-France</span>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-blue-400 flex-shrink-0" />
                <a href="tel:0783518918" className="hover:text-blue-400 transition-colors">
                  07 83 51 89 18
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-blue-400 flex-shrink-0" />
                <a href="mailto:cg.enrgies@gmail.com" className="hover:text-blue-400 transition-colors break-all">
                  cg.enrgies@gmail.com
                </a>
              </li>
              <li className="text-sm text-gray-400 mt-4">
                <div className="font-semibold text-white mb-1">Horaires</div>
                <div>Lun - Sam : 8h - 19h</div>
                <div>Dimanche : sur urgence</div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} CG ÉNERGIES. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-blue-400 transition-colors">Mentions Légales</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Politique de Confidentialité</a>
              <a href="#" className="hover:text-blue-400 transition-colors">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;